module.exports = __webpack_public_path__ + "static/media/LogoCarnaval_Preta.16860c2a.png";